import { useAppSelector } from '@monorepo/shared';
import { selectLoginSaml } from '@monorepo/shared/store/accountSlice';
import { Outlet } from 'react-router-dom';
import { t } from 'i18next';
import './CredMain.less';

const CredMain = () => {
  const loginSaml = useAppSelector(selectLoginSaml);
  return (
    <div className="new-cred-container">
      <div className="left-panel">
        <div className="content">
          <div className="info-container">
            <div className="info-header">
              <div className="title" style={{ marginBottom: '20px' }}>
                {t('common.ouTree.welcomeMsg')}
              </div>
              <div className="login-info">
                {Object.keys(loginSaml?.displayData)?.map(
                  (key: string, idx: number) => (
                    <div key={idx} className="info-item">
                      <div className="name">{key}</div>
                      <div className="value" style={{ maxWidth: '250px' }}>
                        {`${loginSaml?.displayData?.[key]}`}
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="right-panel">
        <Outlet />
      </div>
    </div>
  );
};

export default CredMain;
